import * as React from "react";

import { Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";

export type TooltipWrapperTargetProps = Omit<
  React.HTMLProps<HTMLDivElement>,
  "id"
>;

export interface TooltipWrapperProps {
  children: React.ReactNode;
  content?: string;
  /** @deprecated position is handled automatically by React Aria */
  position?: string;
  allowMultiline?: boolean;
  "aria-hidden"?: boolean;
}

/** No longer needed — React Aria renders overlays in its own portal. */
export function TooltipWrapperTarget(_props: TooltipWrapperTargetProps) {
  return null;
}

export function TooltipWrapper({
  children,
  content,
  allowMultiline,
}: TooltipWrapperProps) {
  if (!content) {
    return <>{children}</>;
  }

  return (
    <Tooltip content={content} allowMultiline={allowMultiline}>
      <TooltipFocusableTrigger>{children}</TooltipFocusableTrigger>
    </Tooltip>
  );
}
